export type LABColor = [number, number, number];

export type HSLColor = {
  h: number;
  s: number;
  l: number;
};

export const DefaultPallet = {
  "--primary": "#5A52C3",
  "--secondary": "#00AF91",
  "--default": "#243443",
  "--white": "#FFFFFF",
  "--black": "#000000",
};

export const isPaletteColor = (colorKey: string) => {
  return Object.keys(DefaultPallet).some(
    (defaultKey) => defaultKey === colorKey,
  );
};
